// Login-form view identifiers.
//
// Kept in its own module (with no imports) so it can be shared by both
// `actions/users` and `reducers/users` without creating a circular import.
// `reducers/users` reads `views.login` at module-init time, so `views` must
// always be defined before that module is evaluated.
export const views = {
  login: 0,
  register: 1,
  verificationCode: 2
}
